import { g as n } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as r, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCallAbandoned",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], h = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4 2.957V4a.5.5 0 0 1-1 0V1.75a.5.5 0 0 1 .5-.5h2.25a.5.5 0 0 1 0 1H4.706L6.5 4.043l1.896-1.897a.5.5 0 0 1 .707.707l-2.25 2.25a.5.5 0 0 1-.707 0L4 2.957Zm4.09 3.924a7.222 7.222 0 0 0-3.195 0h-.004a7.41 7.41 0 0 0-3.116 1.505.317.317 0 0 0-.11.231.331.331 0 0 0 .093.244l.002.001.862.877a.296.296 0 0 0 .397.035 5.652 5.652 0 0 1 1.094-.667l.001-.001a.31.31 0 0 0 .131-.115.329.329 0 0 0 .051-.174v-.733a.5.5 0 0 1 .365-.482 6.838 6.838 0 0 1 3.686 0 .5.5 0 0 1 .365.482v.733c0 .063.019.123.051.174a.31.31 0 0 0 .13.115h.002c.388.18.755.405 1.094.669a.296.296 0 0 0 .393-.032l.004-.004.854-.868a.321.321 0 0 0 .091-.243.329.329 0 0 0-.11-.23 7.41 7.41 0 0 0-3.127-1.516l-.004-.001Zm.219-.976a8.222 8.222 0 0 0-3.632 0 8.41 8.41 0 0 0-3.54 1.71l-.006.006a1.317 1.317 0 0 0-.465.954 1.331 1.331 0 0 0 .381.989h.001l.849.864a1.3 1.3 0 0 0 1.731.14l.004-.003c.28-.218.582-.403.901-.551a1.31 1.31 0 0 0 .555-.485c.135-.212.207-.457.208-.707v-.346a5.836 5.836 0 0 1 2.416 0v.346a1.326 1.326 0 0 0 .763 1.192l.21-.454-.211.454c.32.148.623.333.902.551l.004.003a1.296 1.296 0 0 0 1.72-.13l.853-.866a1.321 1.321 0 0 0 .377-.989 1.329 1.329 0 0 0-.464-.95l-.006-.005a8.41 8.41 0 0 0-3.55-1.723Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  h
], f = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z",
  transform: "translate(.5)"
}, null, -1), v = [
  p
];
function g(e, b, i, I, q, t) {
  return r(), d("svg", {
    "aria-label": i.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--call-abandoned"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Call Abandoned",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, m, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, f)
    ])
  ], 10, _);
}
const D = /* @__PURE__ */ s(c, [["render", g]]);
export {
  D as default
};
//# sourceMappingURL=call-abandoned.js.map
